/**
 * 
 */

import styled from 'styled-components'

export const theme = {
  sansFont:
    'tenso, greek-and-cyrillic-fallback, vdl-v7gothic, source-han-sans-simplified-c, source-han-sans-traditional',
  serifFont: 'freight-text-pro, palatino, serif',
}

export const MaxWidthContainer = styled.div`
  max-width: 1667px;
  margin: 0 auto;
`
